export default "__VITE_ASSET__1c255e9a__"